import { useState, useEffect, useContext, useMemo } from 'react'
import { useLocation, useParams, useNavigate } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'


import { AppContext } from '/providers/app-context'
import { getPass, getPassNotifications } from '/providers/passes-api'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/pass-notifications'
import Menu from '/components/passes/pass-nav-menu'
import NotificationsTable from '/components/passes/notifications-table'

const PassMessages = () => {

  const navigate = useNavigate()
  
  const { templateId, passId } = useParams()
  const { apiSource, apiKey, templates, setPasses } = useContext(AppContext)

  const location = useLocation()

  const [pass, setPass] = useState(location.state?.pass)
  const template = useMemo(() => {return templates.filter(t => t.template_id === templateId)[0]}, [templates, templateId])


  useEffect(() => {
    getPassData()
  }, [templateId, passId])

  const getPassData = async () => {
    const p = await getPass({ apiSource, apiKey, passId })
    if (p.ok === false || !p.pass) return navigate("/templates")
    setPasses(current => {
      const idx = current.findIndex(item => item.template_id === templateId && item.pass_id === passId)
      if (idx < 0) return [...current, p.pass]
      const next = [...current]
      next[idx] = p.pass
      return next
    })
    setPass(p.pass)
  }

  return (
    <PageWrapper title="Pass Messages" HelpText={HelpText} heading={`${pass?.pass_id} ${pass?.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template}/>}>
      <Content templateId={templateId} pass={pass} />        
    </PageWrapper>
  )
}

export default PassMessages

const Content = ({ pass }) => {

  if (pass) {
    const { templateId, passId } = useParams()
    const { apiSource, apiKey } = useContext(AppContext)

    useEffect(() => {
      getNotifications()
    }, [templateId, passId])

    const [notifications, setNotifications] = useState([])
    const [loading, setLoading] = useState(true)

    const getNotifications = async () => {
      const n = await getPassNotifications({ apiSource, apiKey, passId })
      if (n.ok) {
        setNotifications(n.notifications)
      } else {
        enqueueSnackbar({ message: n.error, variant: 'error' })
      }

      setLoading(false)
    }

    return (
      <>
        <div className='flex flex-row h-full w-full gap-5 overflow-auto max-w-full'>
          <NotificationsTable templateId={templateId} pass={pass} data={notifications} loading={loading} refreshNotifications={getNotifications}/>
        </div>
      </>
    )
  }
}
